import Marquee from "react-fast-marquee";
import { MARQUEE } from "../data";

export const MarqueeStrip = () => {
  return (
    <section data-testid="marquee-strip" className="py-2 lg:py-4 bg-primary overflow-hidden">
      <Marquee speed={55} gradient={false} autoFill>
        {MARQUEE.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-item text-3xl lg:text-5xl px-6 text-primary-foreground">{word}</span>
            <span className="font-accent text-2xl lg:text-4xl text-primary-foreground/60 px-6">&</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
